<p-table
  #dt
  [value]="data"
  [paginator]="showPaginator"
  [rows]="rows"
  [sortMode]="showSort ? 'multiple' : 'single'"
  [loading]="loading"
  [globalFilterFields]="globalFilterFields"
  scrollable="true"
  scrollDirection="both"
  scrollHeight="flex"
  class="reusable-table"
  selectionMode="multiple"
  [selectionMode]="selectionMode"
  [(selection)]="selectedRows"
  (selectionChange)="selectedRowsChange.emit($event)"
  emptyMessage="No data available"
  (onFilter)="onTableFiltered($event)"
  [lazy]="true"
  [totalRecords]="totalRecords"
  [first]="first"
  (onLazyLoad)="loadDataLazy($event)"
>
  <ng-template #caption class="header-template-container">
    <div class="global-search-container" *ngIf="!hideTableHeader">
      <div class="pagination-info-top-left">
        Showing {{ getPaginationStart() }} to {{ getPaginationEnd() }} of
        {{ totalRecords }} entries
      </div>

      <div *ngIf="sideFilterConfig" class="sideFilters">
        <app-filter
          *ngFor="let f of sideFilterConfig; trackBy: trackByFilterKey"
          [config]="f"
          [value]="filterValue[f.key]"
          (valueChange)="filterChanged.emit({ key: f.key, value: $event })"
          (searchClicked)="searchClicked.emit()"
          (optionsLazyLoad)="filterOptionsLazyLoad.emit($event)"
        >
        </app-filter>
      </div>
      <div class="pagination-info-top-right">
        <button
          pButton
          *ngIf="showConditionalButton && conditionalButtonConfig"
          type="button"
          [label]="conditionalButtonConfig.label"
          [class]="conditionalButtonConfig.class"
          [pTooltip]="conditionalButtonConfig.tooltip"
          tooltipPosition="top"
          (click)="emitConditionalButtonClick()"
          [disabled]="(selectedRows ?? []).length === 0"
          class="filter-action-button"
        ></button>
        <button
          pButton
          *ngIf="showExportButton"
          type="button"
          label="Export"
          icon="pi pi-upload"
          class="filter-button"
          (click)="emitExportClick()"
        ></button>
        <p-iconfield iconPosition="left" *ngIf="showGlobalFilter">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            class="global-search"
            type="text"
            pInputText
            [(ngModel)]="globalFilterValue"
            (input)="applyGlobalFilter($event)"
            placeholder="Search..."
            [readonly]="isSearchLocked || loading"
            appNoLeadingSpace
          />
        </p-iconfield>
        <button
          *ngIf="filterConfig && filterConfig.length"
          pButton
          type="button"
          label="Filters"
          [icon]="isFilterVisible ? 'pi pi-filter-slash' : 'pi pi-filter'"
          class="filter-button"
          (click)="toggleFilters()"
        ></button>
      </div>
    </div>
    <div
      *ngIf="filterConfig && filterConfig.length"
      class="filters"
      [style.display]="isFilterVisible ? 'flex' : 'none'"
      [@slideToggle]="isFilterVisible ? 'visible' : 'hidden'"
    >
      <app-filter
        *ngFor="let f of filterConfig; trackBy: trackByFilterKey"
        [config]="f"
        [value]="filterValue[f.key]"
        (valueChange)="onFilterChanged({ key: f.key, value: $event })"
        (optionsLazyLoad)="filterOptionsLazyLoad.emit($event)"
      >
      </app-filter>
      <div class="filter-action-row">
        <button
          pButton
          type="button"
          label="Apply"
          class=""
          (click)="onSearchClick()"
        ></button>
      </div>
      <div class="reset-action-row">
        <button
          pButton
          type="button"
          label="Reset"
          class=""
          (click)="resetFilters()"
        ></button>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th *ngIf="selectionMode === 'multiple'" style="width: 3rem" scope="col">
        <p-tableHeaderCheckbox class="custom-checkbox"></p-tableHeaderCheckbox>
      </th>
      <th
        *ngFor="let col of columns"
        [pSortableColumn]="showSort && col.sortable ? col.field : undefined"
        [style.max-width]="col.maxWidth"
        [style.width]="col.width"
        scope="col"
      >
        <div class="header-content">
          <span>{{ col.header }}</span>
          <div class="icons-container">
            <p-sortIcon
              *ngIf="showSort && col.sortable"
              [field]="col.field"
            ></p-sortIcon>
            <p-columnFilter
              *ngIf="showFilter && col.filterable"
              type="text"
              [field]="col.field"
              display="menu"
            ></p-columnFilter>
          </div>
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowData>
    <tr
      [pSelectableRow]="selectionMode ? rowData : null"
      [pSelectableRowDisabled]="true"
    >
      <td *ngIf="selectionMode === 'multiple'">
        <p-tableCheckbox
          class="custom-checkbox"
          [value]="rowData"
        ></p-tableCheckbox>
      </td>
      <td *ngFor="let col of columns" [style.width]="col.width">
        <!-- Check for customCellComponent -->
        <ng-container *ngIf="col.customCellComponent; else checkCustomTemplate">
          <ng-container
            *ngComponentOutlet="col.customCellComponent;
                                injector: getCustomCellInjector(rowData[col.field])"
          ></ng-container>
        </ng-container>

        <ng-template #checkCustomTemplate>
          <!-- Check for isCustom and customTemplate -->
          <ng-container *ngIf="col.isCustom && col.customTemplate; else checkActionOrStatus">
            <div [innerHTML]="col.customTemplate(rowData)"></div>
          </ng-container>
        </ng-template>

        <ng-template #checkActionOrStatus>
          <ng-container *ngIf="col.isAction; else checkStatus">
            <div class="action-buttons-wrapper">
              <button
                *ngFor="let action of actions"
                pButton
                type="button"
                [ngClass]="action.class"
                [pTooltip]="action.tooltip"
                tooltipPosition="top"
                [label]="action.label"
                (click)="action.onClick(rowData)"
              ></button>
            </div>
          </ng-container>
        </ng-template>

        <ng-template #checkStatus>
          <!-- OLD: col.isStatus logic. You might want to remove this if all status rendering is handled by isCustom -->
          <ng-container *ngIf="col.isStatus; else checkProgress">
            <span
              class="status-pill"
              [ngStyle]="{
                backgroundColor: getStatusStyle(rowData[col.field])
                  .backgroundColor,
                color: getStatusStyle(rowData[col.field]).color
              }"
            >
              <div class="status-content">
                <span class="status-text">{{ rowData[col.field] }}</span>
              </div>
            </span>
          </ng-container>
        </ng-template>

        <ng-template #checkProgress>
          <ng-container *ngIf="col.isProgress; else checkCustomActionBtn">
            <div class="progress-display-wrapper" *ngIf="rowData?.display_status !== 'Draft' && rowData?.display_status !== 'Cancelled' && rowData?.display_status !== 'Deleted'"> <!-- New wrapper div -->
              <div class="progress-bar-track"> <!-- This is the background track -->
                <div class="progress-bar-fill" [style.width]="calculateProgressWidth(rowData[col.field])"></div>
              </div>
              <span class="progress-text-value">{{ rowData[col.field] }}</span> <!-- Text value next to the bar -->
            </div>
          </ng-container>
        </ng-template>

        <ng-template #checkCustomActionBtn>
          <ng-container *ngIf="col.isCustomButton; else normalCell">
            <div class="custom-action-buttons-wrapper" *ngIf="isFromActionRoute || (currentUserRole !== 'Local RA (Bayer RA colleague)' && currentUserRole !== 'Local RA (Dealer & Distributor)')">
              <ng-container *ngIf="rowData?.display_status === 'Submitted'">
                <button *ngIf="!rowData?.was_draft" pButton type="button" label="View" (click)="onCustomToggle(rowData, 'View')"></button>
                <button *ngIf="customDetailVisibilityFn && customDetailVisibilityFn(rowData)" pButton type="button" icon="pi pi-ellipsis-v" class="p-button-secondary p-button-icon-only"
                  (click)="toggleOverlayPanel($event, rowData)"></button>
                <p-overlayPanel #op>
                  <ng-template pTemplate="content">
                    <div class="overlay-panel-content" *ngIf="(rowData?.display_status === 'Submitted' || (currentUserRole !== 'RA Admin'))">
                      <button pButton type="button" label="Extend Due Date" class="p-button-text"
                        (click)="onCustomToggle(overlayContextRow, 'Extend Due Date'); op.hide()"></button>
                      <button pButton type="button" label="Mark as Completed" class="p-button-text" *ngIf="showActionButton(overlayContextRow)"
                        (click)="onCustomToggle(overlayContextRow, 'Mark as Completed'); op.hide()"></button>
                      <button pButton type="button" label="Cancel Assessment" class="p-button-text" *ngIf="showActionButton(overlayContextRow)"
                        (click)="onCustomToggle(overlayContextRow, 'Cancel Assessment'); op.hide()"></button>
                    </div>
                  </ng-template>
                </p-overlayPanel>
                <!-- Right-aligned icons for RA Admin and Global RA -->
                <div class="admin-actions-right" *ngIf="currentUserRole === 'RA Admin' || currentUserRole === 'Global RA'">
                  <button pButton type="button" icon="pi pi-share-alt" pTooltip="Share" tooltipPosition="top" class="icon-rca-button"
                    (click)="onCustomToggle(rowData, 'Share')" [disabled]="shareButtonDisabledFn ? shareButtonDisabledFn(rowData) : false"></button>
                  <button pButton type="button" icon="pi pi-copy" pTooltip="Duplicate" tooltipPosition="top" class="icon-rca-button"
                    (click)="onCustomToggle(rowData, 'Duplicate')"></button>
                  <button pButton type="button" icon="pi pi-trash" pTooltip="Delete" tooltipPosition="top" class="delete-rca-button"
                    [disabled]="rowData?.display_status === 'Deleted' || (deleteButtonDisabledFn && deleteButtonDisabledFn(rowData))" (click)="onCustomToggle(rowData, 'Delete')"></button>
                </div>
              </ng-container>
              <ng-container
                *ngIf="rowData?.display_status === 'Completed' || rowData?.display_status === 'Cancelled' || rowData?.display_status === 'Deleted'">
                <button *ngIf="!rowData?.was_draft" pButton type="button" label="View" (click)="onCustomToggle(rowData, 'View')"></button>
                <!-- <button pButton type="button" label="Extend Due Date"
                (click)="onCustomToggle(overlayContextRow, 'Extend Due Date')"></button> -->
                <button *ngIf="customDetailVisibilityFn && customDetailVisibilityFn(rowData) && (reviseButtonVisibilityFn && reviseButtonVisibilityFn(rowData) || rowData?.display_status === 'Completed')" pButton type="button" icon="pi pi-ellipsis-v" class="p-button-secondary p-button-icon-only"
                (click)="toggleOverlayPanel($event, rowData)"></button>
                <p-overlayPanel #op>
                  <ng-template pTemplate="content">
                    <div class="overlay-panel-content">
                      <button *ngIf="reviseButtonVisibilityFn && reviseButtonVisibilityFn(overlayContextRow)" class="p-button-text" pButton type="button" label="Revise" (click)="onCustomToggle(overlayContextRow, 'Revise'); op.hide() "></button>
                      <button *ngIf="rowData?.display_status === 'Completed'" pButton type="button" label="Extend Due Date" class="p-button-text"
                        (click)="onCustomToggle(overlayContextRow, 'Extend Due Date'); op.hide()"></button>
                      </div>
                  </ng-template>
                </p-overlayPanel>
                <!-- Right-aligned icons for RA Admin and Global RA -->
                <div class="admin-actions-right" *ngIf="currentUserRole === 'RA Admin' || currentUserRole === 'Global RA'">
                  <button pButton type="button" icon="pi pi-share-alt" pTooltip="Share" tooltipPosition="top" class="icon-rca-button"
                    (click)="onCustomToggle(rowData, 'Share')" [disabled]="shareButtonDisabledFn ? shareButtonDisabledFn(rowData) : false"></button>
                  <button pButton type="button" icon="pi pi-copy" pTooltip="Duplicate" tooltipPosition="top" class="icon-rca-button"
                    (click)="onCustomToggle(rowData, 'Duplicate')"></button>
                  <button pButton type="button" icon="pi pi-trash" pTooltip="Delete" tooltipPosition="top" class="delete-rca-button"
                    [disabled]="rowData?.display_status === 'Deleted' || (deleteButtonDisabledFn && deleteButtonDisabledFn(rowData))" (click)="onCustomToggle(rowData, 'Delete')"></button>
                </div>
              </ng-container>
              <ng-container *ngIf="rowData?.display_status === 'Draft'">
                <button *ngIf="customDetailVisibilityFn && customDetailVisibilityFn(rowData)" pButton type="button" label="Resume" (click)="onCustomToggle(rowData, 'Resume')"></button>
                <!-- Right-aligned icons for RA Admin and Global RA -->
                <div class="admin-actions-right" *ngIf="currentUserRole === 'RA Admin' || currentUserRole === 'Global RA'">
                  <button pButton type="button" icon="pi pi-share-alt" pTooltip="Share" tooltipPosition="top" class="icon-rca-button"
                    (click)="onCustomToggle(rowData, 'Share')" [disabled]="shareButtonDisabledFn ? shareButtonDisabledFn(rowData) : false"></button>
                  <button pButton type="button" icon="pi pi-copy" pTooltip="Duplicate" tooltipPosition="top" class="icon-rca-button"
                    (click)="onCustomToggle(rowData, 'Duplicate')"></button>
                  <button pButton type="button" icon="pi pi-trash" pTooltip="Delete" tooltipPosition="top" class="delete-rca-button"
                    [disabled]="rowData?.display_status === 'Deleted' || (deleteButtonDisabledFn && deleteButtonDisabledFn(rowData))" (click)="onCustomToggle(rowData, 'Delete')"></button>
                </div>
              </ng-container>
              <ng-container *ngIf="rowData?.response_status === 'Received'">
                <button *ngIf="!rowData?.was_draft" pButton type="button" label="View" (click)="onCustomToggle(rowData, 'ViewReceived')"></button>
                <ng-container *ngIf="currentUserRole === 'Global RA' || currentUserRole === 'RA Admin'">
                  <button pButton type="button" label="Change Assignee" (click)="onCustomToggle(rowData, 'ChangeAssignee')"></button>
                  <button pButton type="button" label="Remove Assignee" (click)="onCustomToggle(rowData, 'RemoveAssignee')" [disabled]="!rowData.assigned_to_user_id"></button>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="rowData?.response_status === 'Pending'">
                <ng-container *ngIf="currentUserRole === 'Global RA' || currentUserRole === 'RA Admin'">
                  <button pButton type="button" label="Change Assignee" (click)="onCustomToggle(rowData, 'ChangeAssignee')"></button>
                  <button pButton type="button" label="Remove Assignee" (click)="onCustomToggle(rowData, 'RemoveAssignee')" [disabled]="!rowData.assigned_to_user_id"></button>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="rowData?.response_status === 'Pending' || rowData?.response_status === 'Received'">
                <i class="pi pi-envelope info-icon" (click)="onCustomToggle(rowData, 'Mail')"></i>
              </ng-container>
              <ng-container *ngIf="rowData?.response_status === 'Yet to Start'">
                <ng-container *ngIf="!rowData.assigned_to_user_id">
                  <button pButton type="button" label="Start" [pTooltip]="assessmentDetails?.status_name === 'Completed' ? 'This assessment cannot be started or submitted because the due date has passed.': ''" [disabled]="assessmentDetails?.status_name === 'Completed'" (click)="onCustomToggle(rowData, 'Start')"></button>
                  <button pButton type="button" label="Assign" (click)="onCustomToggle(rowData, 'Assign')"></button>
                </ng-container>
                <ng-container *ngIf="rowData.assigned_to_user_id && customButtonVisibilityFn && customButtonVisibilityFn(rowData)">
                  <button pButton type="button" label="Start" [pTooltip]="assessmentDetails?.status_name === 'Completed' ? 'This assessment cannot be started or submitted because the due date has passed.': ''" [disabled]="assessmentDetails?.status_name === 'Completed'" (click)="onCustomToggle(rowData, 'Start')"></button>
                  <button pButton type="button" label="Change Assignee" (click)="onCustomToggle(rowData, 'ChangeAssignee')"></button>
                  <button pButton type="button" label="Remove Assignee" (click)="onCustomToggle(rowData, 'RemoveAssignee')"></button>
                </ng-container>
                <ng-container *ngIf="rowData.assigned_to_user_id && (customButtonVisibilityFn && !customButtonVisibilityFn(rowData))">
                  <button *ngIf="!rowData?.was_draft" pButton type="button" label="View" (click)="onCustomToggle(rowData, 'View')"></button>
                  <button pButton type="button" label="Change Assignee" (click)="onCustomToggle(rowData, 'ChangeAssignee')"></button>
                  <button pButton type="button" label="Remove Assignee" (click)="onCustomToggle(rowData, 'RemoveAssignee')"></button>
                </ng-container>
                <!-- Right-aligned icons for RA Admin and Global RA -->
                <div class="admin-actions-right" *ngIf="currentUserRole === 'RA Admin' || currentUserRole === 'Global RA'">
                  <button pButton type="button" icon="pi pi-share-alt" pTooltip="Share" tooltipPosition="top" class="icon-rca-button"
                    (click)="onCustomToggle(rowData, 'Share')" [disabled]="shareButtonDisabledFn ? shareButtonDisabledFn(rowData) : false"></button>
                  <button pButton type="button" icon="pi pi-copy" pTooltip="Duplicate" tooltipPosition="top" class="icon-rca-button"
                    (click)="onCustomToggle(rowData, 'Duplicate')"></button>
                  <button pButton type="button" icon="pi pi-trash" pTooltip="Delete" tooltipPosition="top" class="delete-rca-button"
                    [disabled]="rowData?.display_status === 'Deleted' || (deleteButtonDisabledFn && deleteButtonDisabledFn(rowData))" (click)="onCustomToggle(rowData, 'Delete')"></button>
                </div>
              </ng-container>
              <ng-container *ngIf="rowData?.response_status === 'Submitted'">
                <ng-container *ngIf="currentUserRole === 'Local RA (Bayer RA colleague)' || currentUserRole === 'Local RA (Dealer & Distributor)'">
                  <button *ngIf="!rowData?.was_draft" pButton type="button" label="View" (click)="onCustomToggle(rowData, 'View')"></button>
                  <button pButton type="button" *ngIf="rowData.assigned_to_user_id && customButtonVisibilityFn && customButtonVisibilityFn(rowData)" [pTooltip]="assessmentDetails?.status_name === 'Completed' ? 'Revision is no longer available as the due date has passed.' : ''" [disabled]="assessmentDetails?.status_name === 'Completed'" label="Revise" (click)="onCustomToggle(rowData, 'Revise')"></button>
                </ng-container>
                <ng-container *ngIf="(currentUserRole !== 'Local RA (Bayer RA colleague)' && currentUserRole !== 'Local RA (Dealer & Distributor)') && rowData.assigned_to_user_id && (customButtonVisibilityFn && !customButtonVisibilityFn(rowData))">
                  <button *ngIf="!rowData?.was_draft" pButton type="button" label="View" (click)="onCustomToggle(rowData, 'View')"></button>
                  <button pButton type="button" label="Change Assignee" (click)="onCustomToggle(rowData, 'ChangeAssignee')"></button>
                  <button pButton type="button" label="Remove Assignee" (click)="onCustomToggle(rowData, 'RemoveAssignee')"></button>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="rowData?.response_status === 'Ongoing'">
                <ng-container *ngIf="currentUserRole === 'Local RA (Bayer RA colleague)' || currentUserRole === 'Local RA (Dealer & Distributor)'">
                  <ng-container *ngIf="rowData.assigned_to_user_id && customButtonVisibilityFn && customButtonVisibilityFn(rowData)">
                    <button pButton type="button" label="Resume" [disabled]="assessmentDetails?.status_name === 'Completed'" [pTooltip]="assessmentDetails?.status_name === 'Completed'? 'Cannot resume response as the assessment is already completed.': ''" (click)="onCustomToggle(rowData, 'Resume')"></button>
                    <button pButton type="button" label="Change Assignee" (click)="onCustomToggle(rowData, 'ChangeAssignee')"></button>
                    <button pButton type="button" label="Remove Assignee" (click)="onCustomToggle(rowData, 'RemoveAssignee')"></button>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="rowData.assigned_to_user_id && (customButtonVisibilityFn && !customButtonVisibilityFn(rowData))">
                  <button *ngIf="!rowData?.was_draft" pButton type="button" label="View" (click)="onCustomToggle(rowData, 'View')"></button>
                  <button pButton type="button" label="Change Assignee" (click)="onCustomToggle(rowData, 'ChangeAssignee')"></button>
                  <button pButton type="button" label="Remove Assignee" (click)="onCustomToggle(rowData, 'RemoveAssignee')"></button>
                </ng-container>
                <ng-container *ngIf="!rowData.assigned_to_user_id && (customButtonVisibilityFn && !customButtonVisibilityFn(rowData))">
                  <button pButton type="button" label="Assign" (click)="onCustomToggle(rowData, 'Assign')"></button>
                </ng-container>
              </ng-container>
            </div>
            <div class="custom-action-buttons-wrapper" *ngIf="!isFromActionRoute  && (currentUserRole === 'Local RA (Bayer RA colleague)' || currentUserRole === 'Local RA (Dealer & Distributor)')">
              <ng-container>
                <button *ngIf="!rowData?.was_draft" pButton type="button" label="View" (click)="onCustomToggle(rowData, 'View')"></button>
              </ng-container>
            </div>
          </ng-container>
        </ng-template>

        <ng-template #normalCell>
          <ng-container *ngIf="col.truncateAt as max; else noTruncate">
            <span pTooltip="{{ (rowData[col.field] | json) ? (rowData[col.field]) : '' }}"  tooltipStyleClass="custom-tooltip">{{ (rowData[col.field] | json) ? (rowData[col.field] | truncate:max) : '' }}</span>
          </ng-container>
          <ng-template #noTruncate>
            <span>{{ rowData[col.field] }}</span>
            <i *ngIf="col.hasVersionIcon" class="pi pi-info-circle info-icon" (click)="toggleVersionOverlayPanel($event, rowData)"></i>
          </ng-template>
        </ng-template>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td
        [attr.colspan]="columns.length + (selectionMode === 'multiple' ? 1 : 0)"
        class="empty-message-cell"
      >
        <div class="empty-message-wrapper">No matching records found.</div>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-overlayPanel #versionOp>
  <ng-template pTemplate="content">
    <div class="version-overlay-content">
      <div *ngFor="let item of currentVersions" class="version-item" (click)="navigateToVersion(currentRcaId)">
        {{ item.version }}
      </div>
    </div>
  </ng-template>
</p-overlayPanel>